import { render, staticRenderFns } from "./MiniCategories.vue?vue&type=template&id=bc25c9b2&scoped=true&"
import script from "./MiniCategories.vue?vue&type=script&lang=js&"
export * from "./MiniCategories.vue?vue&type=script&lang=js&"
import style0 from "./MiniCategories.vue?vue&type=style&index=0&id=bc25c9b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc25c9b2",
  null
  
)

export default component.exports